// extracted by mini-css-extract-plugin
export default {"jobBySkills":"Right_jobBySkills__E5wh3","right":"Right_right__O3YbG"};